
import { Button, FormControl, FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";

import { styled } from "styled-components"
import theme from "../../styles/theme"

import CommonModalBar from "../common/CommonModalBar";
import { getClientFromBizno, getCompanyInfo, useGetClients } from "../../interfaces/clients";
import React, { useEffect, useState } from "react";
import { formatBizNo } from "../../common/util";
import CommonDataGrid from "../common/CommonDataGrid";
import { useQueryClient } from "react-query";
import { MODAL_QUERY_NM } from "../../interfaces/modal";

const MainWrap = styled.div`
    position: absolute;
    top:0;
    left:0;
    // border: 1px solid red;
    background: ${theme.color.white[100]};
    width: 100%;
    height: 100%;
    border-radius: 18px;
    padding: 1rem 1rem;
    z-index:1;

    .row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 8px;
        font-size: 1rem;
    }
`

const columns = [
    { field: 'company', headerName: '업체명', flex: 1, headerAlign:'center' },
    { field: 'bno', headerName: '사업자번호', flex:1, headerAlign:'center' },
]

const SearchClient = ({setSearchInfo, close}) => {

    const queryClient = useQueryClient();

    const {data: clientList} = useGetClients();

    const [searchMode, setSearchMode] = useState('3');
    const [searchResult, setSearchResult] = useState();
    const [searchBizNo, setSearchBizNo] = useState('');
    const [searchNm, setSearchNm] = useState('');

    const [selectItem, setSelectItem] = useState();
    const [selectItemDetail, setSelectItemDetail] = useState();

    useEffect(() =>{
        if(selectItem){
            async function getCompany (selectItem){
                const companyInfo = await getCompanyInfo(selectItem.bno.replaceAll('-',''))
                if(companyInfo.err!==true){
                    const temp = {
                        owner_nm: companyInfo.owner_nm,
                        zipcode: companyInfo.zipcode,
                        addr: companyInfo.addr,
                        phn_no_o: companyInfo.phn_no_o,
                        fax_no: companyInfo.fax_no,
                    }
                    setSelectItemDetail(temp);
                }else{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:companyInfo.message,
                            height:'20vh',
                        }
                    );
            }}
            getCompany(selectItem);
        }
    },[selectItem])

    const search = async () => {
        let value = '';
        if(searchMode === '3'){
            value = searchNm;
        }else{
            value = searchBizNo.replaceAll('-','')
        }
        if(value && value.length>0){
            const temp = await getClientFromBizno({
                searchMode: searchMode,
                value:value
            })
            setSearchResult(temp.filter((item)=>item!==null).map((item,index)=>({
                ...item,
                id:index
            })));
            setSelectItem();
        }
    }
    const handleEtcReg = () => {
        const temp = clientList.findIndex((item)=>item.biz_no === searchBizNo.replaceAll('-',''))
        if(temp < 0){
            setSearchInfo && setSearchInfo({bno:searchBizNo.replaceAll('-',''),company:searchNm,biz_tp:'CZ'}); 
            close();
        }else{
            queryClient.setQueryData(
                [MODAL_QUERY_NM],
                {
                    show:true,
                    msg:'이미 등록된 업체입니다.',
                    height:'20vh',
                }
            )
        }
        
    }

    const handleCloseClick = () => {
        close();
    }

    const handleCompleteClick = () => {
        const temp = clientList.findIndex((item)=>item.biz_no === selectItem.bno.replaceAll('-',''))
        if(temp < 0){
            setSearchInfo && setSearchInfo({...selectItem,...selectItemDetail,biz_tp: 'ZZ'}); 
            close();
        }else{
            queryClient.setQueryData(
                [MODAL_QUERY_NM],
                {
                    show:true,
                    msg:'이미 등록된 업체입니다.',
                    height:'20vh',
                }
            )
        }
    }

    const handleKeydown = (e) => {
        if(e.keyCode === 13) {
            search();
        }

    }

    return (
        <MainWrap>
            <CommonModalBar title={'고객사 검색'} close={handleCloseClick}/>
            <FormControl>
                <RadioGroup
                    row
                    aria-labelledby="is_ing-label"
                    defaultValue={''}
                    name="is_ing"
                    value={searchMode}
                    onChange={(e)=>setSearchMode(e.target.value)}
                >
                    <FormControlLabel value={'3'} control={<Radio />} label={`업체명`} />
                    <FormControlLabel value={'1'} control={<Radio />} label={`사업자번호`} />
                    <FormControlLabel value={'X'} control={<Radio />} label={`기타(개인 등)`} />
                </RadioGroup>
            </FormControl>
            
            <div className="row">
                { searchMode !== 'X' ? 
                    searchMode === '3' ?
                        <TextField
                                id='nm'
                                label='업체명'
                                size='small'
                                value={searchNm}
                                onChange={(e)=>setSearchNm(e.target.value)}
                                onKeyDown={handleKeydown}
                            />
                        :
                        <TextField
                                id='bizNo'
                                label='사업자번호'
                                size='small'
                                value={searchBizNo}
                                onChange={(e)=>setSearchBizNo(formatBizNo(e.target.value.replaceAll('-','')))}
                                onKeyDown={handleKeydown}
                            />
                    :
                        <React.Fragment>
                            <TextField
                                    id='nm'
                                    label='업체명(이름)'
                                    size='small'
                                    value={searchNm}
                                    onChange={(e)=>setSearchNm(e.target.value)}
                                    onKeyDown={handleKeydown}
                            />
                            <TextField
                                id='bizNo'
                                label='구분번호'
                                size='small'
                                value={searchBizNo}
                                onChange={(e)=>setSearchBizNo(formatBizNo(e.target.value.replaceAll('-','')))}
                                onKeyDown={handleKeydown}
                            />
                        </React.Fragment>
                }
                {searchMode !== 'X' ? 
                    <Button variant='contained' onClick={search}>고객사 검색</Button>
                    : <Button variant='contained' onClick={handleEtcReg}>입력완료</Button>
                }
            </div>
            {(selectItem && selectItemDetail) &&
                <div className="row" style={{margin:'1rem 0rem 0rem 0rem', fontSize:'0.8rem'}}>
                    <span>{selectItem.company} / {selectItem.bno} / {selectItemDetail.owner_nm} / {selectItemDetail.phn_no_o}
                    <br/>/ {selectItemDetail.addr}</span>
                    <Button variant='contained' onClick={handleCompleteClick}>선택</Button>
                </div>
            }
            <div style={{margin:'1rem 0rem',height:'70%'}}>
                {searchResult &&
                <CommonDataGrid
                    // isLoading={!(searchResult.length > 0)}
                    list={searchResult}
                    columns={columns}
                    onRowClick={(e)=>setSelectItem(e.row)}
                    hideFooterRowCount={true}
                />}
            </div>
        </MainWrap>
    )
}

export default SearchClient